import { Stack, styled } from "@/theme/index";

export const StyledStack = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  position: "sticky",
  top: 65,
  zIndex: 10,
  backgroundColor: theme.palette.background.paper,
  borderTop: "1px solid #E6E7E9",
  borderInline: "1px solid #E6E7E9",
  borderRadius: "8px",
  padding: theme.spacing(2.5),
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",

  [theme.breakpoints.up("md")]: {
    top: 76,
  },
}));
